export enum SubmissionProcessStatePermissions {
    ViewSubmission = 'Pillar2.Submission.View',
    CreateSubmission = 'Pillar2.Submission.Create',
    EditSubmission = 'Pillar2.Submission.Edit',
    ReviewSubmission = 'Pillar2.Submission.Review',
    RevokeReviewSubmission = 'Pillar2.Submission.RevokeReview',
    SubmitSubmission = 'Pillar2.Submission.Submit',
    RevokeReadyForSubmission = 'Pillar2.Submission.RevokeReadyForSubmission',
    DeleteSubmission = 'Pillar2.Submission.Delete',
}
